import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export function ProtectedRoute({ managerOnly = false }: { managerOnly?: boolean }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return <div className="centered muted">Loading…</div>

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />
  }

  if (managerOnly && user.role !== 'manager') {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
